import { render, staticRenderFns } from "./ResendConfirmCodePage.vue?vue&type=template&id=25e21304&scoped=true"
import script from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts"
export * from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts"
import style0 from "./ResendConfirmCodePage.vue?vue&type=style&index=0&id=25e21304&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e21304",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25e21304')) {
      api.createRecord('25e21304', component.options)
    } else {
      api.reload('25e21304', component.options)
    }
    module.hot.accept("./ResendConfirmCodePage.vue?vue&type=template&id=25e21304&scoped=true", function () {
      api.rerender('25e21304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/ResendConfirmCodePage.vue"
export default component.exports